import React from 'react'
import { InputAdornment, TextField, Typography } from '@mui/material';
import { colors } from '../../constants/colors';

export type colorProps = {
    disabled?: boolean;
    heading?: string;
    placeholder?: string;
    onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
    value: string;
    headingAlign?: React.CSSProperties['textAlign'];
    headingNormal?: boolean;
    required?: boolean;
    markRequired?: string;
}

const ColorPicker: React.FC<colorProps> = (props: colorProps) => {
    const { disabled, heading, placeholder, onChange, value } = props;
    return (
        <div className='w-full overflow-hidden'>
            {props.heading && (
                <div
                    className="pb-[1px]"
                    style={{ textAlign: props.headingAlign || "left" }}
                >
                    <Typography variant={props.headingNormal ? 'subtitle1' : 'body1'}>
                        {heading}{" "} {props.required || props.markRequired ? <span style={{ color: colors.red }}>*</span> : ""}
                    </Typography>
                </div>
            )}
            <span className='w-full'>
                <TextField
                    InputProps={{
                        sx: {
                            height: 50, // ปรับให้เท่ากับ input ทั่วไป
                        },
                        endAdornment: (
                            <InputAdornment sx={{ ml: 2, display: 'flex', justifyContent: 'center', alignItems: 'center' }} position="start">
                                <Typography variant='h5' sx={{ fontSize: 14, mr: 1 }}>{value.toUpperCase()}</Typography>
                            </InputAdornment>
                        ),
                    }}
                    sx={{
                        width: "100%",
                        ".MuiOutlinedInput-input": {
                            height: 30,
                            minWidth: 50,
                            width: 40,
                            fontSize: 16,
                            color: `${colors.textPrimary} !important`,
                            textOverflow: "ellipsis",
                            "-webkit-text-fill-color": "unset !important",
                            // padding: "0 1rem",
                            "&.Mui-disabled": {
                                color: `${colors.black_60} !important`,
                            },
                            "&::placeholder": {
                                opacity: 1,
                                color: `${colors.placeholder} !important`,
                            },
                        },
                    }}
                    disabled={disabled}
                    placeholder={placeholder}
                    value={value}
                    onChange={onChange}
                    type='color'
                />
            </span>
        </div>
    )
}

export default ColorPicker